<template>
  <div id="app">
    <div class="clearfix">
      <div class="loadingOverlay" v-if="isAuth && authUser.loader">
        <div class="loading"></div>
      </div>
      <auth-layout v-if="isAuth"></auth-layout>
      <div class="admin-container" v-else>
        <Sidebar :navItems="nav" v-bar />
        <div id="right-panel" class="right-panel fHeight">
          <div class>
            <Header></Header>
            <div class="content pb-0">
              <spinner v-if="authUser.loader"></spinner>
              <transition enter-active-class="animated fadeIn">
                <router-view></router-view>
              </transition>
            </div>
            <footer class="footer-area">
              <div class="row">
                <div class="col-md-12">
                  <p>Copyright © Upachaya Infotech Pvt. Ltd. All Rights Reserved</p>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nav from "./nav";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar.vue";
import AuthLayout from "./layouts/AuthLayout.vue";
import spinner from "./components/spinner";
import auth from "./lib/auth.js";
export default {
  data() {
    return {
      nav: nav.items,
      authUser: auth.user
    };
  },
  components: {
    AuthLayout,
    Header,
    Sidebar,
    spinner
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    },
    isAuth() {
      console.log(
        "Match",
        this.$route.path,
        this.$route.path.match("auth"),
        auth.user,
        auth.user.authenticated
      );
      // return !(auth.user && auth.user.authenticated);
      return this.$route.path.match("auth");
    }
  },
  // watch: {
  //   authUser(value) {
  //     this.authUser = value;
  //   }
  // },
  // updated: function() {
  //   this.$nextTick(function() {      
  //   });
  // }
};
</script>

<style lang="scss">
@import url("./assets/css/font-awesome.min.css");
@import url("./assets/css/themify-icons.css");
@import url("./assets/css/pe-icon-7-filled.css");
@import url("./assets/css/flag-icon.min.css");
@import url("./assets/css/cs-skin-elastic.css");

@import "./assets/scss/style";
body {
  font-size: 14px;
}

button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue